import type { SVGProps } from 'react';
const SvgBadge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#badge_svg__a)">
      <path
        fill="currentColor"
        d="M20 7h-5V4c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2ZM9 12c.83 0 1.5.67 1.5 1.5S9.83 15 9 15s-1.5-.67-1.5-1.5S8.17 12 9 12Zm3 6H6v-.75c0-1 2-1.5 3-1.5s3 .5 3 1.5V18Zm1-9h-2V4h2v5Zm5 7.5h-4V15h4v1.5Zm0-3h-4V12h4v1.5Z"
      />
    </g>
    <defs>
      <clipPath id="badge_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBadge;
